import React from 'react'
import Bradcom from '../../components/Bradcom/Main'
import First from '../Menprivacy/First'

const Application = () => {
  return (
    <>
        <Bradcom title={"Home"} subtitle={"Privacy"} common={"Privacy Policy"}/>
        <First/>
    </>
  )
}

export default Application